import isEmpty from 'lodash/isEmpty';

import * as actionTypes from './actiontypes';
import states from './states';

export default function botmessage_details(state = states.botmessage_details, action) {
    switch (action.type) {     
        case actionTypes.BOT_MESSAGES_LOADING: {
            return {
                ...state,
                loaders: {
                    ...state.loaders,
                    bot_messages_loading: true,
                    bot_messages_loaded: false,
                }
            };
        }

        case actionTypes.BOT_MESSAGES_LOADED: {
            return {
                ...state,
                bot_messages: action.payload && action.payload.botMessageData ? action.payload.botMessageData : [...state.bot_messages],
                loaders: {
                    ...state.loaders,
                    bot_messages_loading: false,
                    bot_messages_loaded: true,
                }
            };
        }

        case actionTypes.BOT_MESSAGES_ERROR: {
            return {
                ...state,
                loaders: {
                    ...state.loaders,
                    bot_messages_loading: false,
                    bot_messages_loaded: false,
                }
            };
        }

        case actionTypes.BOT_MESSAGE_SCHEMA_LOADED: {
            return {
                ...state,
                bot_messages_schema: action.payload && action.payload.botMessagesSchema ? action.payload.botMessagesSchema : {},
                bot_messages_ui_schema: action.payload && action.payload.botMessagesUISchema ? action.payload.botMessagesUISchema : {},
                context_variables_data: action.payload && action.payload.contextVariablesData ? action.payload.contextVariablesData : {},
            };
        }

        case actionTypes.BOT_MESSAGE_DELETED: {
            const index = state.bot_messages.findIndex((message) => {
                return (message.id === action.payload.id)
            });

            return {
                ...state,
                bot_messages: index !== -1 ? [...state.bot_messages.slice(0, index), ...state.bot_messages.slice(index + 1)] : [...state.bot_messages],
            };
        }

        case actionTypes.RESET_POPUP_BOT_MESSAGE: {
            return {
                ...state,
                message_form_data: {}
            };
        }

        case actionTypes.BOT_MESSAGE_DETAIL_LOADED: {
            return {
                ...state,
                message_form_data: action.payload && action.payload.messageDetails ? action.payload.messageDetails : {}
            };
        }

        case actionTypes.BOT_MESSAGE_UPDATING: {
            return {
                ...state,
                loaders: {
                    ...state.loaders,
                    bot_message_updating: true,
                }
            };
        }

        case actionTypes.BOT_MESSAGE_UPDATED: {
            const index = state.bot_messages.findIndex((message) => {
                return action.payload && action.payload.botMessageDataPoint && action.payload.botMessageDataPoint.id && (message.id === action.payload.botMessageDataPoint.id)
            });

            return {
                ...state,
                bot_messages: index !== -1 ? [...state.bot_messages.slice(0, index), action.payload.botMessageDataPoint, ...state.bot_messages.slice(index + 1)] : [...state.bot_messages],
                loaders: {
                    ...state.loaders,
                    bot_message_updating: false,
                }
            };
        }

        case actionTypes.BOT_MESSAGE_CREATED: {
            return {
                ...state,
                bot_messages: action.payload && action.payload.botMessageDataPoint && !isEmpty(action.payload.botMessageDataPoint) ? [action.payload.botMessageDataPoint, ...state.bot_messages] : [...state.bot_messages],
                loaders: {
                    ...state.loaders,
                    bot_message_updating: false,
                }
            };
        }

        case actionTypes.BOT_MESSAGE_UPDATION_ERROR: {
            return {
                ...state,
                loaders: {
                    ...state.loaders,
                    bot_message_updating: false,
                }
            };
        }

        case actionTypes.UPDATE_MESSAGE_FORM_DATA: {
            return {
                ...state,
                message_form_data: action.payload && action.payload.type ? { ...action.payload } : { ...state.message_form_data },
            }
        }

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/data/redux/botmessage_details/reducers.js